window.addEventListener( "pageshow", function ( event ) {
  if (window.performance.navigation.type === 2) {
    window.location.reload();
  }
});
